/* eslint-disable prettier/prettier */
import React from 'react'
import Typography from '@material-ui/core/Typography'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'

import { useNotificationSettingsCardStyles } from './notification-settings-card.styles'

type NotificationSettingsCardProps = {
  title: string
}

export const NotificationSettingsCard: React.FC<NotificationSettingsCardProps> =
  (props) => {
    const classes = useNotificationSettingsCardStyles()

    return (
      <div className={classes.root}>
        <Card>
          <CardContent>
            <Typography variant="h5" className={classes.title}>
              {props.title}
            </Typography>
            <div className={classes.selectRow}>{props.children}</div>
          </CardContent>
        </Card>
      </div>
    )
  }
